/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Directive, ElementRef, Input} from '@angular/core';
import {MedallionStyle} from "../../models/schedule/metadata/EntryMedallion";

@Directive({
  selector: 'score-icon',
})
export class ScoreIconComponent {

  private _medallion: MedallionStyle;

  @Input()
  set medallion(m: MedallionStyle) {
    this._medallion = m;
    if (m) {
      this.generate();
    }
  }

  constructor(private element: ElementRef) {

  }

  private generate() {
    const color = this._medallion.color ? this._medallion.color : '#cc0000';
    const identifier = this._medallion.name ? this._medallion.name : '!';

    this.element.nativeElement.style.backgroundColor = color;
    this.element.nativeElement.setAttribute('value', identifier);
    }

}



// WEBPACK FOOTER //
// ./src/components/score-icon/score-icon.ts